import React from 'react';

import PropTypes, { oneOfType } from 'prop-types';
import style from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';

/**
 * 定义 select 组件
 */
class Select extends React.PureComponent {
    static propTypes = {
        onSelectChange: PropTypes.func,
        onChange: PropTypes.func,
        defaultValue: PropTypes.object,
        options: PropTypes.array,
        error: PropTypes.bool,
        value: oneOfType([PropTypes.object, PropTypes.string]),
        width: PropTypes.number,
        styles: PropTypes.object,
    };

    static defaultProps = {
        onSelectChange: () => {},
        // onChange: () => {},
        defaultValue: { label: '请选择', value: '' },
        options: [],
        error: false,
        width: 240,
    };

    state = {
        defaultValue: this.props.defaultValue,
        isShowSelect: false,
        error: this.props.error,
        isChanged: false,
        value: this.props.value,
        choosedValue: '',
    };

    ref = null;
    arrowRef = null;

    componentDidMount = () => {
        if (window) {
            addEventListener(window, 'click', e => {
                if (e.target !== this.ref && e.target !== this.arrowRef) {
                    this.setState({
                        isShowSelect: false,
                    });
                }
            });
        }
    };

    static getDerivedStateFromProps(nextProps, state) {
        let resError = {};
        let resValue = {};
        let resDefaultValue = {};

        if (nextProps.error !== state.error) {
            resError = {
                error: nextProps.error,
            };
        }
        if (nextProps.value !== state.value) {
            resValue = {
                value: nextProps.value,
            };
        }
        if (nextProps.defaultValue !== state.defaultValue && !state.choosedValue) {
            resDefaultValue = {
                defaultValue: nextProps.defaultValue,
            };
        }

        return {
            ...resError,
            ...resValue,
            ...resDefaultValue,
        };
    }

    componentWillUnMount() {
        this.setState({
            defaultValue: { label: '请选择', value: '' },
            isShowSelect: false,
        });
    }

    handleClick = data => {
        // console.log(data);
        this.setState(
            {
                choosedValue: data,
                defaultValue: data,
                isShowSelect: false,
                isChanged: true,
            },
            () => {
                this.props.onSelectChange(data);
                this.props.onChange(data);
            },
        );
    };

    showSelect = e => {
        this.setState({
            isShowSelect: !this.state.isShowSelect,
        });
    };

    componentWillUnmount = () => {
        this.setState = () => {
            return null;
        };
    };

    /**
     * 渲染组件
     */
    render() {
        const { defaultValue, isShowSelect, error, isChanged, value } = this.state;
        const { options, width, styles } = this.props;
        const choosedValue = value ? value : defaultValue;

        return (
            <div
                className={`${style.questionType} ${error ? style.error : ''}`}
                style={{ width: `${width}px`, ...styles }}>
                <span
                    className={choosedValue.value ? '' : style.defaultStyle}
                    onClick={this.showSelect}
                    ref={ref => (this.ref = ref)}
                    value={choosedValue.value}>
                    {choosedValue.label}
                </span>
                <div className={style.arrow} onClick={this.showSelect} ref={ref => (this.arrowRef = ref)} />
                <ul style={{ display: isShowSelect ? 'block' : 'none' }}>
                    {options.map((item, index) => {
                        return (
                            <li key={index} data-key={item.value} onClick={this.handleClick.bind(this, item)}>
                                {item.label}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}
export default errorBoundary(Select);
